import * as CSS from 'csstype';


export const containerStyles: CSS.Properties = { 
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',   
}
export const logoStyles: CSS.Properties = { 
    alignSelf: 'center',
    height: '35rem',
    marginLeft: '4rem'

}
export const headerStyles: CSS.Properties = { 
    color: '#6A7FDB',
    textAlign: 'center',
    marginLeft: '4rem',

}

export const promptStyles: CSS.Properties = { 
    marginBottom: '5rem',
    color: 'white',
    textAlign: 'center',
    marginLeft: '4rem'

}
export const buttonGroupStyles: CSS.Properties = { 
    justifyContent: 'center',
    marginLeft: '4rem',
    width: 'fit-content',
}

export const buttonDiv: CSS.Properties = { 
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '5rem'
}

export const buttons: CSS.Properties = { 
    backgroundColor: '#45CB85',
    width: '8rem'
}




